import { useQuery } from "@tanstack/react-query";

import { getBatchHistory } from "@/api/audit-api";

interface UseBatchHistoryParams {
	machineGroupId: string | undefined;
	currentUserId: string | undefined;
}

export const useBatchHistory = ({ machineGroupId, currentUserId }: UseBatchHistoryParams) => {
	const queryKey = ["orders-history", machineGroupId, currentUserId] as const;

	return useQuery({
		queryKey,
		queryFn: () => getBatchHistory(machineGroupId!),
		enabled: Boolean(machineGroupId),
	});
};
